"use client";

import { cn } from "@workspace/ui";
import { Icons } from "@workspace/ui/components/icons";

import { ThemedImage } from "~/components/common/themed-image";
import { ReviewAuthor } from "~/components/marketing/home/core/reviews/grid";
import { REVIEWS } from "~/lib/constants/reviews";

export const HeroReview = ({
  className,
  reviewId,
  stars,
}: {
  className?: string;
  reviewId: string;
  stars?: number;
}) => {
  const review = REVIEWS.find((review) => review.id === reviewId);

  if (!review) {
    return null;
  }

  return (
    <div
      className={cn(
        "mx-auto mt-4 flex flex-col items-center gap-12 md:mt-6 md:flex-row lg:mt-10",
        className,
      )}
    >
      {review?.revenue && (
        <div className="flex flex-col items-center gap-3 md:flex-col-reverse md:items-start">
          <>
            <a
              href={review.revenue.link}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all duration-300 hover:brightness-95 dark:hover:brightness-80"
            >
              <ThemedImage
                light={review.revenue.image.light}
                dark={review.revenue.image.dark}
                alt={review.revenue.image.alt}
                width={970}
                height={856}
                className="w-120 max-w-full rounded-xl border"
                unoptimized
              />
            </a>

            <div className="flex items-center justify-center gap-2">
              <Icons.CheckmarkBadge01Icon className="text-primary size-5.5 " />
              <span className="text-muted-foreground font-medium">
                Built with TurboStarter
              </span>
            </div>
          </>
        </div>
      )}

      <div className="mx-auto flex max-w-md flex-col items-center gap-4 md:items-start">
        <Icons.QuoteUpIcon className="text-muted-foreground size-7 max-md:mx-auto md:size-8" />
        {stars && (
          <div className="flex items-center justify-center">
            {Array.from({ length: stars }).map((_, index) => (
              <Icons.Star key={index} className="fill-primary size-6.5" />
            ))}
          </div>
        )}
        <p className="leading-relaxed text-pretty max-md:text-center md:text-lg">
          {review?.quote}
        </p>
        {review && (
          <ReviewAuthor
            author={review.author}
            className="origin-top-left md:scale-110"
          />
        )}
      </div>
    </div>
  );
};
